import React, {useState} from 'react';
import InputMUISearch from '../../../shared/InputMUISearch';
import {NavLink} from 'react-router-dom';
import {mainPath} from '../../../routes/paths';
import {ReactComponent as LocationIcon} from '../../../assets/icons/location.svg';
import {ReactComponent as AvatarIcon} from '../../../assets/images/companies/avatar.svg';
import './YourCompanies.scss';
import {useDispatch, useSelector} from 'react-redux';
import CompaniesSkeleton from './CompaniesSkeleton/CompaniesSkeleton';
import NoItems from '../../Components/NoItems';
import {setModal} from '../../../redux/actions/app/appActions';
import {POPUPS} from '../../../redux/actions/app/appActionTypes';
import {useTranslation} from 'react-i18next';
import {hasPermission} from '../../../helpers/functions';
import {PERMISSIONS} from '../../../helpers/constants';

const YourCompanies = ({onCompanySelect}) => {
  const dispatch = useDispatch();
  const companyList = useSelector(({company}) => company.companies);
  const companyLoading = useSelector(({company}) => company.companiesLoading);
  const {profileMe} = useSelector((state) => state.profile);
  const {t} = useTranslation();

  const [searchCompanies, setSearchCompanies] = useState('');

  const handleClear = () => {
    setSearchCompanies('');
  };

  const handleChange = (event) => {
    setSearchCompanies(event.target.value);
  };

  const filteredCompanies = companyList.filter((company) =>
    company.name.toLowerCase().includes(searchCompanies.toLowerCase())
  );

  const handleNavigate = () => {
    dispatch(setModal(POPUPS.COMPANY_POPUP));
  };

  return (
    <div className='your-companies'>
      {companyLoading ? (
        <CompaniesSkeleton loading={companyLoading} />
      ) : (
        <>
          <div className='your-companies__list'>
            {companyList.length > 0 ? (
              <>
                <div className='your-companies__head'>
                  <div className='your-companies__head-title'>{t('YourCompanies.myCompaniesTitle')}</div>
                </div>
                <div className='your-companies__search'>
                  <InputMUISearch
                    className='search-box__input'
                    fullWidth
                    value={searchCompanies}
                    onClear={handleClear}
                    onChange={handleChange}
                    placeholder={t('YourCompanies.searchPlaceholder')}
                  />
                </div>
                {filteredCompanies.map((company) => {
                  const rating = company?.rate || 0;
                  const fillPercentage = (rating / 5) * 100;
                  return (
                    <NavLink
                      className={`companies-item`}
                      key={company.id}
                      to={mainPath.company.replace(':id', company.id)}
                      onClick={onCompanySelect}
                    >
                      <div className='companies-item__image'>
                        {company.logo ? <img src={company.logo} alt={company.id} /> : <AvatarIcon />}
                      </div>
                      <div className='companies-item__info'>
                        <div className='companies-item__address'>{company.name}</div>
                        <div className='companies-item__place'>
                          <LocationIcon />
                          {company.city?.name ?? company.address}
                        </div>
                        <div className='companies-item__details'>
                          <div className='companies-item__rating'>
                            <svg
                              width='16'
                              height='16'
                              viewBox='0 0 16 16'
                              fill='none'
                              xmlns='http://www.w3.org/2000/svg'
                            >
                              <defs>
                                <linearGradient id={`starGradient-${company.id}`} x1='0%' y1='0%' x2='100%' y2='0%'>
                                  <stop offset={`${fillPercentage}%`} stopColor='#FFB508' />
                                  <stop offset={`${fillPercentage}%`} stopColor='transparent' />
                                </linearGradient>
                              </defs>
                              <path
                                d='M8.51782 1.65535L10.1524 4.95543C10.1896 5.03919 10.2481 5.11175 10.3221 5.16586C10.396 5.21998 10.4829 5.25376 10.5739 5.26385L14.1824 5.79844C14.2869 5.81187 14.3854 5.85475 14.4665 5.92207C14.5475 5.9894 14.6077 6.07838 14.64 6.17863C14.6724 6.27889 14.6755 6.38628 14.6491 6.48825C14.6227 6.59023 14.5678 6.68259 14.4909 6.75454L11.8899 9.33498C11.8235 9.397 11.7737 9.47464 11.7449 9.56082C11.7162 9.64701 11.7095 9.73901 11.7254 9.82845L12.3525 13.4575C12.3707 13.5618 12.3592 13.6691 12.3194 13.7672C12.2796 13.8652 12.213 13.9502 12.1273 14.0123C12.0416 14.0744 11.9402 14.1113 11.8346 14.1186C11.729 14.1259 11.6235 14.1035 11.53 14.0538L8.28136 12.3369C8.19817 12.2961 8.10673 12.2749 8.01406 12.2749C7.92139 12.2749 7.82995 12.2961 7.74677 12.3369L4.49808 14.0538C4.40462 14.1035 4.29909 14.1259 4.1935 14.1186C4.0879 14.1113 3.98649 14.0744 3.90079 14.0123C3.8151 13.9502 3.74856 13.8652 3.70876 13.7672C3.66895 13.6691 3.65748 13.5618 3.67563 13.4575L4.30275 9.78733C4.31865 9.69789 4.31192 9.60589 4.2832 9.5197C4.25447 9.43352 4.20465 9.35588 4.13826 9.29386L1.50642 6.75454C1.42856 6.68062 1.3738 6.58571 1.34878 6.4813C1.32376 6.37689 1.32955 6.26747 1.36546 6.16628C1.40136 6.0651 1.46583 5.9765 1.55107 5.91121C1.6363 5.84593 1.73864 5.80675 1.84568 5.79844L5.45418 5.26385C5.54527 5.25376 5.63212 5.21998 5.70607 5.16586C5.78003 5.11175 5.83851 5.03919 5.87569 4.95543L7.51031 1.65535C7.55483 1.55923 7.62591 1.47786 7.71517 1.42083C7.80443 1.3638 7.90814 1.3335 8.01406 1.3335C8.11999 1.3335 8.2237 1.3638 8.31296 1.42083C8.40222 1.47786 8.4733 1.55923 8.51782 1.65535V1.65535Z'
                                stroke={fillPercentage > 0 ? '#FFB508' : '#736A85'}
                                strokeWidth='1.5'
                                strokeLinecap='round'
                                strokeLinejoin='round'
                                fill={`url(#starGradient-${company.id})`}
                              />
                            </svg>
                            {company.rate}
                          </div>

                          <div className='companies-item__projects'>
                            <span>{t('YourCompanies.projectsCount')}:</span>
                            {company.projectCount}
                          </div>
                        </div>
                      </div>
                    </NavLink>
                  );
                })}
              </>
            ) : (
              <NoItems
                description={t('YourCompanies.noCompaniesDescription')}
                buttonText={t('YourCompanies.noCompaniesButton')}
                title={t('YourCompanies.noCompaniesTitle')}
                handleNavigate={handleNavigate}
                disabled={!hasPermission(PERMISSIONS.COMPANY_CREATE, profileMe?.permissions ?? [])}
              />
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default YourCompanies;
